import { buildLeadershipFooterFromMembers } from '../constants/leadership';

export const MONTHS = [
  ['January', 'Januari'],
  ['February', 'Februari'],
  ['March', 'Machi'],
  ['April', 'Aprili'],
  ['May', 'Mei'],
  ['June', 'Juni'],
  ['July', 'Julai'],
  ['August', 'Agosti'],
  ['September', 'Septemba'],
  ['October', 'Oktoba'],
  ['November', 'Novemba'],
  ['December', 'Desemba'],
];

export const DEFAULT_INVITATION_FEES = [
  { id: 1, label: 'Active Member (early bird)', amount: '150,000/=', onsite: '180,000/=' },
  { id: 2, label: 'Non-Member (early bird)', amount: '250,000/=', onsite: '280,000/=' },
  { id: 3, label: 'International Delegates', amount: 'USD 200', onsite: '' },
  { id: 4, label: 'Students', amount: '35,000/=', onsite: '' },
  { id: 5, label: 'Annual subscription fee', amount: '30,000/=', onsite: '' },
];

export const DEFAULT_INVITATION_LETTER = {
  orgName: 'Tanzania Dental Association',
  orgAbbrev: 'TDA',
  poBox: 'P.O. Box 65008, Dar-es-Salaam, Tanzania.',
  officeAddress:
    'Office: First Floor\nSchool of Dentistry Building, MUHAS\nDar-es-Salaam, Tanzania\ntanzaniadentalassociation01@gmail.com',
  phone: '+255-758 960 550 / 713291238',
  email: 'info@tdadent.or.tz',
  website: 'www.tdadent.or.tz',
  logoUrl: '/images/tda-logo.png',

  refNumberTemplate: 'TDA/{{year}}/{{ref_suffix}}',
  letterDay: '',
  letterMonth: '',
  letterYear: '',

  recipientName: '',
  recipientInstitution: '',
  recipientAddressLine: '',
  recipientCity: '',

  eventNumber: '41',
  eventStartDay: '25',
  eventEndDay: '27',
  eventMonth: 'November',
  eventYear: '2026',
  location: 'Katavi Region, Tanzania',
  expectedAttendees: '350',

  themeEn: 'Evolving Landscape of Restorative Dental Care in Tanzania',
  themeSw: 'Mwelekeo na Mabadiliko ya Tiba Rekebishi ya Meno Nchini Tanzania',

  locationSw: 'MKOA WA KATAVI',
  conferenceVenueSw: 'Hoteli ya Home Ground Ukumbi wa Phillip, Mpanda Mjini',
  preConference1Day: '23',
  preConference1Text:
    'Utoaji wa huduma za afya ya kinywa na meno kwa watoto wenye mahitaji maalumu- Kituo cha Mt. Yohane II, Manispaa ya Mpanda na Mafunzo ya vitendo kwa wataalamu.',
  preConference2Day: '24',
  preConference2Text:
    'Utoaji wa huduma za afya ya kinywa na meno kwa wananchi- Hospitali ya rufaa ya mkoa Katavi (KRRH) na Mafunzo ya vitendo kwa wataalamu.',

  includeOutreach: true,
  outreachDay: '25',
  outreachMonth: 'November',
  outreachLocationsEn: 'schools for children with special needs in Miyuji Cheshire, Dodoma Viziwi, and Buigiri',
  outreachLocationsSw: 'shule za watoto wenye mahitaji maalum',

  bankName: 'National Microfinance Bank (NMB),',
  accountNumber: '20910006526,',
  branch: 'Muhimbili, Dar es Salaam.',

  signatoryName: 'Dr. Gemma Z. Berege',
  signatoryNameSw: 'Dkt. Gemma Z. Berege',
  signatoryTitle: 'PRESIDENT-TANZANIA DENTAL ASSOCIATION',
  signatoryTitleSw: 'RAIS–CHAMA CHA WATAALAM WA AFYA YA KINYWA NA MENO TANZANIA',
  signatureImage: '/images/tda-president-signature.png',
  stampImage: '/images/tda-official-stamp.png',

  footerNote:
    'For Promotion of Oral Health in Tanzania\nAll correspondences to be addressed to the Hon. Secretary',
  fees: DEFAULT_INVITATION_FEES,
};

export const LETTER_PLACEHOLDERS = [
  { key: 'recipientName', label: 'Delegate full name' },
  { key: 'recipientNameUpper', label: 'Delegate name (UPPERCASE)' },
  { key: 'refNumber', label: 'Reference number' },
  { key: 'eventNumber', label: 'Conference edition number' },
  { key: 'eventStartDay', label: 'Conference start day' },
  { key: 'eventEndDay', label: 'Conference end day' },
  { key: 'eventMonth', label: 'Conference month (English)' },
  { key: 'eventMonthSw', label: 'Conference month (Swahili)' },
  { key: 'eventYear', label: 'Conference year' },
  { key: 'location', label: 'Location' },
  { key: 'locationSw', label: 'Location (Swahili subject)' },
  { key: 'expectedAttendees', label: 'Expected attendees' },
  { key: 'themeEn', label: 'Theme (English)' },
  { key: 'themeSw', label: 'Theme (Swahili)' },
  { key: 'orgName', label: 'Organization name' },
  { key: 'orgAbbrev', label: 'Organization abbreviation' },
  { key: 'preConference1Day', label: 'Pre-conference day 1' },
  { key: 'preConference1Text', label: 'Pre-conference activity 1' },
  { key: 'preConference2Day', label: 'Pre-conference day 2' },
  { key: 'preConference2Text', label: 'Pre-conference activity 2' },
  { key: 'conferenceVenueSw', label: 'Main conference venue (Swahili)' },
  { key: 'bankName', label: 'Bank name' },
  { key: 'accountNumber', label: 'Account number' },
  { key: 'branch', label: 'Bank branch' },
  { key: 'outreachDay', label: 'Outreach day' },
  { key: 'outreachMonth', label: 'Outreach month' },
  { key: 'outreachLocationsEn', label: 'Outreach locations (English)' },
];

const p = (text) => `<p>${text}</p>`;

export const DEFAULT_BODY_SECTIONS_EN = [
  {
    id: 'subject',
    label: 'RE subject line',
    html: p(
      'INVITATION TO PARTICIPATE IN THE {{eventOrdinalEn}} SCIENTIFIC CONFERENCE, CONTINUING PROFESSIONAL DEVELOPMENT WORKSHOP AND ANNUAL GENERAL MEETING FROM {{eventStartDayOrdinal}} TO {{eventEndDayOrdinal}} {{eventMonthUpper}}, {{eventYear}} {{locationUpper}}'
    ),
  },
  { id: 'intro', label: 'Opening line', html: p('Refer to the heading above.') },
  {
    id: 'para2',
    label: 'Paragraph 2 — conference overview',
    number: '2',
    html: p(
      'The {{orgName}} will have its {{eventOrdinalEn}} Scientific Conference, Continuing Professional Development Workshop, and Annual General Meeting in {{location}} on {{eventStartDayOrdinal}} to {{eventEndDayOrdinal}} {{eventMonth}} {{eventYear}}. This annual scientific event and conference will bring together {{orgAbbrev}} members, oral health professionals, and other health stakeholders to share expert experiences. Another goal of this event is to disseminate scientific insights, educational developments, and inspiration through the sharing of accomplishments. This year&apos;s meeting is expected to bring together about {{expectedAttendees}} oral health professionals from within the country and several others across the globe. The dental fraternity continues to flourish and benefits from this professional gathering.'
    ),
  },
  {
    id: 'para3',
    label: 'Paragraph 3 — theme',
    number: '3',
    html: p(
      'The theme for this year&apos;s meeting is &ldquo;{{themeEn}}&rdquo;, (<strong>{{themeSw}}</strong>).'
    ),
  },
  {
    id: 'outreach',
    label: 'Outreach paragraph (optional)',
    html: p(
      'This conference will be preceded by a one-day ({{outreachDayOrdinal}} {{outreachMonth}}, {{eventYear}}) outreach activity to {{outreachLocationsEn}}, where oral health education, oral health checkup and treatment will be offered without any payment.'
    ),
  },
  {
    id: 'para4',
    label: 'Paragraph 4 — invitation',
    number: '4',
    html: p(
      'The Association has the honor to invite you as a member to join in the successful realization of the {{eventOrdinalEn}} Scientific Conference, Continuing Professional Development Workshop and Annual General Meeting that is scheduled to be held from the {{eventStartDayOrdinal}} to {{eventEndDayOrdinal}} {{eventMonth}}, {{eventYear}} in {{location}}.'
    ),
  },
  { id: 'feesIntro', label: 'Fees introduction', html: p('Participation fee will be:-') },
  {
    id: 'para5',
    label: 'Paragraph 5 — payment instructions',
    number: '5',
    html: p(
      'All payments should be addressed to the {{orgName}} through {{bankName}} account detailed below:-'
    ),
  },
  {
    id: 'para6',
    label: 'Paragraph 6 — employer permission',
    number: '6',
    html: p(
      'It is our hope that your employer will grant permission and facilitate your participation in this important conference{{outreachClauseEn}}.'
    ),
  },
  { id: 'closing', label: 'Closing line', html: p('Sincerely yours,') },
];

export const DEFAULT_BODY_SECTIONS_SW = [
  {
    id: 'para2',
    label: 'Paragraph 2',
    number: '2',
    html: p(
      'Chama cha Wataalam wa Kinywa na Meno Tanzania (TDA) hufanya Kongamano la Kisayansi na Mkutano Mkuu wa Mwaka ambapo, wanataaluma wa afya ya kinywa na meno hukutana ili kupokea na kujadili tafiti mbalimbali za kisayansi zinazofanywa na watoa huduma za afya ya kinywa na meno ndani na nje ya nchi. Aidha, masuala mbalimbali yahusuyo afya ya kinywa na meno hujadiliwa.'
    ),
  },
  {
    id: 'para3',
    label: 'Paragraph 3 — theme',
    number: '3',
    html: p(
      'Kauli mbiu ya Kongamano mwaka huu ni: &ldquo;{{themeEn}}&rdquo; ({{themeSw}}).'
    ),
  },
  {
    id: 'para4',
    label: 'Paragraph 4 — pre-conference intro',
    number: '4',
    html: p(
      'Wadau wa Afya ya Kinywa na Meno takribani {{expectedAttendees}} kutoka ndani na nje ya nchi, wakiwemo waajiri, watoa huduma za kinywa na meno na afya kwa ujumla, pamoja na wadau wengine wanatarajiwa kushiriki Kongamano hili litakaloanza tarehe {{eventStartDay}} hadi {{eventEndDay}} {{eventMonthSw}}, {{eventYear}} litahusisha shughuli tangulizi &ldquo;pre conference activities&rdquo; ambazo ni (kutembelea vivutio vya utalii, zoezi la utoaji huduma za afya ya kinywa na meno na mafunzo ya vitendo &ldquo;hands on&rdquo; kwa wanataaluma) pamoja na kongamano lenyewe kama ifuatavyo:-'
    ),
  },
  {
    id: 'preConf1',
    label: 'Pre-conference (i)',
    sublistLabel: 'i',
    html: p(
      'Tarehe {{preConference1Day}} {{eventMonthSw}}, {{eventYear}} - {{preConference1Text}}'
    ),
  },
  {
    id: 'preConf2',
    label: 'Pre-conference (ii)',
    sublistLabel: 'ii',
    html: p(
      'Tarehe {{preConference2Day}} {{eventMonthSw}}, {{eventYear}} - {{preConference2Text}}'
    ),
  },
  {
    id: 'preConf3',
    label: 'Pre-conference (iii)',
    sublistLabel: 'iii',
    html: p(
      'Tarehe {{eventStartDay}} hadi {{eventEndDay}} {{eventMonthSw}} {{eventYear}} - Kongamano la Kisayansi, Mkutano Mkuu wa Mwaka na Uchaguzi Mkuu wa viongozi wa Chama - katika {{conferenceVenueSw}}.'
    ),
  },
  {
    id: 'para5',
    label: 'Paragraph 5 — employer permission',
    number: '5',
    html: p(
      'Uongozi wa TDA, unaiomba ofisi yako kumruhusu na kuwawezesha mtaalamu tajwa wa Kinywa na Meno kushiriki katika kongamano na mazoezi tangulizi kama ilivyoelezwa hapo juu.'
    ),
  },
  {
    id: 'feesIntro',
    label: 'Paragraph 6 — fees introduction',
    number: '6',
    html: p('Gharama za usajili kwa ajili ya kongamano hili ni kama ifuatavyo:-'),
  },
  {
    id: 'para7',
    label: 'Paragraph 7 — payment',
    number: '7',
    html: p(
      'Malipo ya gharama ya ushiriki wa Kongamano yatafanyika kupitia Akaunti ya Chama; Jina la Akaunti: Tanzania Dental Association Benki: {{bankName}} Namba ya Akaunti: {{accountNumber}} Tawi: {{branch}}'
    ),
  },
  {
    id: 'closing',
    label: 'Paragraph 8 — closing',
    number: '8',
    html: p('Nakutakia majukumu mema ya kazi.'),
  },
];

export const getDefaultBodySections = (lang = 'en') =>
  lang === 'sw' ? DEFAULT_BODY_SECTIONS_SW : DEFAULT_BODY_SECTIONS_EN;

const escapeHtml = (value) =>
  String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');

export const buildLetterPlaceholderMap = (data = {}) => {
  const eventMonthSw = monthToSwahili(data.eventMonth);
  const outreachClauseEn = data.includeOutreach
    ? ` and outreach activity (${ordinalSuffix(data.outreachDay)} ${data.outreachMonth}, ${data.eventYear})`
    : '';

  return {
    recipientName: data.recipientName || '',
    recipientNameUpper: String(data.recipientName || 'MWALIKIWA').toUpperCase(),
    refNumber: data.refNumber || '',
    eventNumber: data.eventNumber || '',
    eventOrdinalEn: ordinalSuffix(data.eventNumber),
    eventStartDay: data.eventStartDay || '',
    eventEndDay: data.eventEndDay || '',
    eventStartDayOrdinal: ordinalSuffix(data.eventStartDay),
    eventEndDayOrdinal: ordinalSuffix(data.eventEndDay),
    eventMonth: data.eventMonth || '',
    eventMonthUpper: String(data.eventMonth || '').toUpperCase(),
    eventMonthSw,
    eventMonthSwUpper: eventMonthSw.toUpperCase(),
    eventYear: data.eventYear || '',
    location: data.location || '',
    locationUpper: String(data.location || '').toUpperCase(),
    locationSw: String(data.locationSw || 'MKOA WA KATAVI').toUpperCase(),
    expectedAttendees: data.expectedAttendees || '',
    themeEn: data.themeEn || '',
    themeSw: data.themeSw || '',
    orgName: data.orgName || '',
    orgAbbrev: data.orgAbbrev || '',
    preConference1Day: data.preConference1Day || '',
    preConference1Text: data.preConference1Text || '',
    preConference2Day: data.preConference2Day || '',
    preConference2Text: data.preConference2Text || '',
    conferenceVenueSw: data.conferenceVenueSw || '',
    bankName: data.bankName || '',
    accountNumber: data.accountNumber || '',
    branch: data.branch || '',
    outreachDay: data.outreachDay || '',
    outreachMonth: data.outreachMonth || '',
    outreachDayOrdinal: ordinalSuffix(data.outreachDay),
    outreachLocationsEn: data.outreachLocationsEn || '',
    outreachClauseEn,
  };
};

export const interpolateLetterHtml = (html, data = {}) => {
  const map = buildLetterPlaceholderMap(data);
  return interpolatePlaceholderMap(html, map);
};

export const interpolatePlaceholderMap = (html, map = {}) =>
  String(html || '').replace(/\{\{(\w+)\}\}/g, (match, key) => {
    if (!(key in map)) return match;
    return escapeHtml(map[key]);
  });

export const mergeBodySections = (stored = {}, lang = 'en') => {
  const defaults = getDefaultBodySections(lang);
  const langStored = stored?.[lang] || stored || {};
  const merged = {};
  defaults.forEach((section) => {
    const saved = langStored[section.id];
    merged[section.id] = {
      ...section,
      html: saved?.html ?? saved ?? section.html,
    };
  });
  return merged;
};

export const mergeAllBodySections = (stored = {}) => ({
  en: mergeBodySections(stored, 'en'),
  sw: mergeBodySections(stored, 'sw'),
});

export const getSectionHtml = (data, lang, sectionId) => {
  const sections = data.bodySections?.[lang] || mergeBodySections(data.bodySections, lang);
  const section = sections[sectionId] || getDefaultBodySections(lang).find((s) => s.id === sectionId);
  const html = section?.html || '';
  return interpolateLetterHtml(html, data);
};

export const resolveSubjectLine = (data, lang = 'en') => {
  const html = getSectionHtml(data, lang, 'subject');
  const plain = html.replace(/<[^>]+>/g, '').trim();
  if (plain) return html;
  return lang === 'sw' ? buildSubjectSw(data) : buildSubjectEn(data);
};

export const isSectionEmpty = (html) => !String(html || '').replace(/<[^>]+>/g, '').trim();

export const FULL_BODY_PAGE_BREAK =
  '<p class="ilg-editor-page-break"><strong>——— Page 2 ———</strong></p>';

const FULL_BODY_PAGE_BREAK_PATTERN =
  /<p\b[^>]*class="[^"]*ilg-editor-page-break[^"]*"[^>]*>[\s\S]*?<\/p>/i;

export const usesFullBodyEditMode = (data, lang = 'en') =>
  data?.bodyEditMode === 'full' &&
  Boolean(String(data?.fullBodyHtml?.[lang] || '').replace(/<[^>]+>/g, '').trim());

export const splitFullBodyPages = (html) => {
  const value = String(html || '');
  const match = value.match(FULL_BODY_PAGE_BREAK_PATTERN);
  if (!match) return [value, ''];
  const index = match.index ?? value.indexOf(match[0]);
  return [value.slice(0, index), value.slice(index + match[0].length)];
};

export const joinFullBodyPages = (page1Html, page2Html) => {
  const page1 = String(page1Html || '');
  const page2 = String(page2Html || '').trim();
  if (!page2 || isSectionEmpty(page2)) return page1;
  return `${page1}${FULL_BODY_PAGE_BREAK}${page2}`;
};

const stripOuterParagraph = (html) =>
  String(html || '')
    .replace(/^<p>/i, '')
    .replace(/<\/p>$/i, '');

const buildSubjectLineHtml = (label, rawHtml) => {
  const inner = stripOuterParagraph(rawHtml).replace(/<\/?(?:p|div)\b[^>]*>/gi, ' ').trim();
  if (!inner) return '';
  return `<p class="ilg-subject"><strong>${label}: ${inner}</strong></p>`;
};

const buildNumberedBlockHtml = (lang, sectionId, rawHtml) => {
  if (isSectionEmpty(rawHtml)) return '';
  const meta = getDefaultBodySections(lang).find((section) => section.id === sectionId);
  if (!meta?.number) return `<div class="ilg-rich-block">${rawHtml}</div>`;
  return `<div class="ilg-numbered-para"><span class="ilg-para-num">${meta.number}.</span><div class="ilg-rich-block ilg-rich-inline">${rawHtml}</div></div>`;
};

const buildSublistBlockHtml = (lang, sectionId, rawHtml) => {
  if (isSectionEmpty(rawHtml)) return '';
  const meta = getDefaultBodySections(lang).find((section) => section.id === sectionId);
  if (!meta?.sublistLabel) return `<div class="ilg-rich-block">${rawHtml}</div>`;
  return `<p class="ilg-sublist-item"><span class="ilg-sublist-label">(${meta.sublistLabel})</span><span class="ilg-rich-block ilg-rich-inline">${stripOuterParagraph(rawHtml)}</span></p>`;
};

const buildEnglishFeesListHtml = (fees = []) => {
  const items = (fees || [])
    .map((row) => {
      const label = escapeHtml(row.label || '');
      const amount = escapeHtml(row.amount || '');
      const onsite = row.onsite ? ` (On site – ${escapeHtml(row.onsite)})` : '';
      return `<li>${label} - ${amount}${onsite}</li>`;
    })
    .join('');
  return `<ol class="ilg-fees-list" type="i">${items}</ol>`;
};

const buildSwahiliFeesListHtml = (fees = []) =>
  buildSwahiliFeesList(fees)
    .map(
      (row) =>
        `<p class="ilg-sublist-item"><span class="ilg-sublist-label">(${row.key})</span><span>${escapeHtml(row.text)}</span></p>`
    )
    .join('');

const buildBankDetailsHtml = (data = {}) =>
  `<div class="ilg-bank-details"><div><strong>Bank:</strong> ${escapeHtml(data.bankName || '')}</div><div><strong>Account Number:</strong> ${escapeHtml(data.accountNumber || '')}</div><div><strong>Branch:</strong> ${escapeHtml(data.branch || '')}</div></div>`;

const getRawSectionHtml = (data, lang, sectionId) => {
  const sections = mergeBodySections(data.bodySections, lang);
  return sections[sectionId]?.html || '';
};

export const assembleFullBodyHtml = (data, lang = 'en') => {
  const langKey = lang === 'sw' ? 'sw' : 'en';
  const stored = String(data?.fullBodyHtml?.[langKey] || '').trim();
  if (stored) return data.fullBodyHtml[langKey];

  const section = (sectionId) => getRawSectionHtml(data, langKey, sectionId);

  if (langKey === 'en') {
    const page1Parts = [
      buildSubjectLineHtml('RE', section('subject')),
      !isSectionEmpty(section('intro')) ? `<div class="ilg-rich-block">${section('intro')}</div>` : '',
      buildNumberedBlockHtml('en', 'para2', section('para2')),
      buildNumberedBlockHtml('en', 'para3', section('para3')),
      data.includeOutreach && !isSectionEmpty(section('outreach'))
        ? `<div class="ilg-rich-block">${section('outreach')}</div>`
        : '',
      buildNumberedBlockHtml('en', 'para4', section('para4')),
      !isSectionEmpty(section('feesIntro')) ? `<div class="ilg-rich-block">${section('feesIntro')}</div>` : '',
      buildEnglishFeesListHtml(data.fees),
    ].filter(Boolean);

    const page2Parts = [
      buildNumberedBlockHtml('en', 'para5', section('para5')),
      buildBankDetailsHtml(data),
      buildNumberedBlockHtml('en', 'para6', section('para6')),
      !isSectionEmpty(section('closing'))
        ? `<div class="ilg-rich-block ilg-closing">${section('closing')}</div>`
        : '',
    ].filter(Boolean);

    return joinFullBodyPages(page1Parts.join('\n'), page2Parts.join('\n'));
  }

  const page1Parts = [
    buildNumberedBlockHtml('sw', 'para2', section('para2')),
    buildNumberedBlockHtml('sw', 'para3', section('para3')),
    buildNumberedBlockHtml('sw', 'para4', section('para4')),
    `<div class="ilg-sublist">${[
      buildSublistBlockHtml('sw', 'preConf1', section('preConf1')),
      buildSublistBlockHtml('sw', 'preConf2', section('preConf2')),
      buildSublistBlockHtml('sw', 'preConf3', section('preConf3')),
    ]
      .filter(Boolean)
      .join('\n')}</div>`,
    buildNumberedBlockHtml('sw', 'para5', section('para5')),
  ].filter(Boolean);

  const page2Parts = [
    buildNumberedBlockHtml('sw', 'feesIntro', section('feesIntro')),
    `<div class="ilg-sublist ilg-fees-sublist">${buildSwahiliFeesListHtml(data.fees)}</div>`,
    buildNumberedBlockHtml('sw', 'para7', section('para7')),
    buildNumberedBlockHtml('sw', 'closing', section('closing')),
  ].filter(Boolean);

  return joinFullBodyPages(page1Parts.join('\n'), page2Parts.join('\n'));
};

export const assembleEmployerFullBodyHtml = (data) => {
  const stored = String(data?.fullBodyHtml?.sw || '').trim();
  if (stored) return data.fullBodyHtml.sw;

  const section = (sectionId) => {
    const sections = mergeEmployerBodySections(data.bodySections);
    return sections[sectionId]?.html || '';
  };

  const page1Parts = [
    buildNumberedBlockHtml('sw', 'para2', section('para2')),
    buildNumberedBlockHtml('sw', 'para3', section('para3')),
    buildNumberedBlockHtml('sw', 'para4', section('para4')),
    `<div class="ilg-sublist">${[
      buildSublistBlockHtml('sw', 'preConf1', section('preConf1')),
      buildSublistBlockHtml('sw', 'preConf2', section('preConf2')),
      buildSublistBlockHtml('sw', 'preConf3', section('preConf3')),
    ]
      .filter(Boolean)
      .join('\n')}</div>`,
    buildNumberedBlockHtml('sw', 'para5', section('para5')),
  ].filter(Boolean);

  const page2Parts = [
    buildNumberedBlockHtml('sw', 'feesIntro', section('feesIntro')),
    `<div class="ilg-sublist ilg-fees-sublist">${buildSwahiliFeesListHtml(data.fees)}</div>`,
    buildNumberedBlockHtml('sw', 'para7', section('para7')),
    buildNumberedBlockHtml('sw', 'closing', section('closing')),
  ].filter(Boolean);

  return joinFullBodyPages(page1Parts.join('\n'), page2Parts.join('\n'));
};

export const stripSwahiliSubjectLine = (html) =>
  String(html || '')
    .replace(/<p\b[^>]*class="[^"]*ilg-subject[^"]*"[^>]*>[\s\S]*?<\/p>\s*/gi, '')
    .replace(/<p\b[^>]*>\s*<strong>\s*YAH:[\s\S]*?<\/p>\s*/gi, '');

export const getInterpolatedFullBodyPageHtml = (data, lang, pageIndex) => {
  const langKey = lang === 'sw' ? 'sw' : 'en';
  const [page1, page2] = splitFullBodyPages(data?.fullBodyHtml?.[langKey] || '');
  let pageHtml = pageIndex === 0 ? page1 : page2;
  if (langKey === 'sw') {
    pageHtml = stripSwahiliSubjectLine(pageHtml);
  }
  return interpolateLetterHtml(pageHtml, data);
};

export const getInterpolatedEmployerFullBodyPageHtml = (data, pageIndex) => {
  const [page1, page2] = splitFullBodyPages(data?.fullBodyHtml?.sw || '');
  let pageHtml = pageIndex === 0 ? page1 : page2;
  pageHtml = stripSwahiliSubjectLine(pageHtml);
  return interpolatePlaceholderMap(pageHtml, buildEmployerLetterPlaceholderMap(data));
};

export const monthToSwahili = (monthEn) => {
  const found = MONTHS.find(([en]) => en === monthEn);
  return found ? found[1] : monthEn;
};

export const ordinalSuffix = (n) => {
  const num = parseInt(n, 10);
  if (Number.isNaN(num)) return `${n}`;
  const mod100 = num % 100;
  if (mod100 >= 11 && mod100 <= 13) return `${num}th`;
  switch (num % 10) {
    case 1:
      return `${num}st`;
    case 2:
      return `${num}nd`;
    case 3:
      return `${num}rd`;
    default:
      return `${num}th`;
  }
};

const parseDateParts = (isoDate) => {
  if (!isoDate) return null;
  const d = new Date(`${isoDate}T12:00:00`);
  if (Number.isNaN(d.getTime())) return null;
  return {
    day: String(d.getDate()),
    month: MONTHS[d.getMonth()]?.[0] || '',
    year: String(d.getFullYear()),
  };
};

export const mergeInvitationLetterSettings = (stored = {}, conferenceSettings = {}) => {
  const { leadershipFooter: _storedFooter, ...storedFields } = stored;
  const letter = {
    ...DEFAULT_INVITATION_LETTER,
    ...storedFields,
    fees: stored.fees?.length ? stored.fees : DEFAULT_INVITATION_LETTER.fees,
  };

  letter.refNumberTemplate = normalizeRefNumberTemplate(letter.refNumberTemplate);

  if (!letter.signatureImage) {
    letter.signatureImage = DEFAULT_INVITATION_LETTER.signatureImage;
  }
  if (!letter.stampImage || letter.stampImage === '/images/tda-stamp.png') {
    letter.stampImage = DEFAULT_INVITATION_LETTER.stampImage;
  }

  if (conferenceSettings.location && !stored.location) {
    letter.location = conferenceSettings.location;
  }
  if (conferenceSettings.theme?.title && !stored.themeEn) {
    letter.themeEn = conferenceSettings.theme.title;
  }

  const start = parseDateParts(conferenceSettings.conference_start);
  const end = parseDateParts(conferenceSettings.conference_end);
  if (start) {
    letter.eventStartDay = start.day;
    letter.eventMonth = start.month;
    letter.eventYear = start.year;
  }
  if (end) {
    letter.eventEndDay = end.day;
    if (!start) {
      letter.eventMonth = end.month;
      letter.eventYear = end.year;
    }
  }

  const editionMatch = String(conferenceSettings.hero_title || '').match(/(\d+)/);
  if (editionMatch && !stored.eventNumber) {
    letter.eventNumber = editionMatch[1];
  }

  letter.bodySections = mergeAllBodySections(stored.bodySections);

  return letter;
};

const normalizeCompare = (value) =>
  String(value || '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, ' ');

const PO_BOX_PATTERN = /^(p\.?\s*o\.?\s*box|s\.?\s*l\.?\s*p\.?|postal\s*box|box)\b/i;
const BUILDING_PATTERN = /\b(building|floor|block|wing|room|suite|muhas|first|second|third)\b/i;

const splitAddressParts = (rawAddress) =>
  String(rawAddress || '')
    .split(/[,\n]+/)
    .map((part) => part.trim())
    .filter(Boolean);

const looksLikeCity = (segment) => {
  const value = String(segment || '').trim();
  if (!value) return false;
  if (PO_BOX_PATTERN.test(value)) return false;
  if (BUILDING_PATTERN.test(value)) return false;
  if (/^\d/.test(value)) return false;
  return true;
};

const stripCountrySuffix = (city, country) => {
  const cityValue = String(city || '').trim();
  const countryNorm = normalizeCompare(country);
  if (!cityValue || !countryNorm) return cityValue;

  const cityNorm = normalizeCompare(cityValue);
  if (cityNorm === countryNorm) return '';
  if (cityNorm.endsWith(`, ${countryNorm}`)) {
    return cityValue.slice(0, cityValue.length - country.length - 1).trim();
  }
  if (cityNorm.endsWith(countryNorm) && cityNorm.length > countryNorm.length) {
    return cityValue.slice(0, cityValue.length - country.length).replace(/,\s*$/, '').trim();
  }
  return cityValue;
};

const appendCountryIfMissing = (city, country, addressText = '') => {
  let recipientCity = String(city || '').trim();
  const countryNorm = normalizeCompare(country);
  const addressNorm = normalizeCompare(addressText);

  if (!recipientCity && country && !addressNorm.includes(countryNorm)) {
    return country;
  }
  if (
    recipientCity &&
    country &&
    !normalizeCompare(recipientCity).includes(countryNorm) &&
    !addressNorm.includes(countryNorm)
  ) {
    return `${recipientCity}, ${country}`;
  }
  return recipientCity;
};

export const parseRecipientAddress = ({
  organization = '',
  address = '',
  po_box = '',
  region = '',
  city = '',
  country = '',
} = {}) => {
  const institution = String(organization || '').trim();
  const institutionNorm = normalizeCompare(institution);
  let parts = splitAddressParts(address || po_box);

  while (parts.length && normalizeCompare(parts[0]) === institutionNorm) {
    parts.shift();
  }

  let recipientCity = String(region || city || '').trim();
  const countryNorm = normalizeCompare(country);

  if (!recipientCity && parts.length > 1 && countryNorm) {
    const lastNorm = normalizeCompare(parts[parts.length - 1]);
    if (lastNorm === countryNorm) {
      parts = parts.slice(0, -1);
    }
  }

  if (!recipientCity && parts.length === 1 && looksLikeCity(parts[0])) {
    recipientCity = parts[0];
    parts = [];
  } else if (!recipientCity && parts.length > 1 && looksLikeCity(parts[parts.length - 1])) {
    recipientCity = parts[parts.length - 1];
    parts = parts.slice(0, -1);
  }

  recipientCity = stripCountrySuffix(recipientCity, country);
  recipientCity = appendCountryIfMissing(recipientCity, country, parts.join(', '));

  const recipientAddressLines = parts.length > 0 ? [parts.join(', ')] : [];
  const recipientAddressLine = recipientAddressLines.join(', ');

  return {
    recipientInstitution: institution,
    recipientAddressLines,
    recipientAddressLine,
    recipientCity,
  };
};

export const buildRecipientFromRegistration = (registration) => {
  if (!registration) return {};
  const name =
    [registration.first_name, registration.middle_name, registration.last_name]
      .filter(Boolean)
      .join(' ')
      .trim() ||
    String(registration.fullName || registration.full_name || registration.name || '').trim();

  const parsed = parseRecipientAddress({
    organization: registration.organization,
    address: registration.address,
    po_box: registration.po_box,
    region: registration.region,
    city: registration.city,
    country: registration.country,
  });

  return {
    recipientName: name,
    ...parsed,
    ref_suffix: deriveRefSuffixFromRegistration(registration),
  };
};

const SENDER_ORG_PATTERNS = [
  /tanzania dental association/i,
  /\btda\b/i,
  /chama cha wataalam wa afya ya kinywa na meno/i,
];

const SENDER_ADDRESS_PATTERNS = [
  /65008/i,
  /\bmuhas\b/i,
  /school of dentistry/i,
  /first floor/i,
  /tdadent\.or\.tz/i,
  /tanzaniadentalassociation/i,
];

const matchesSenderPattern = (value, patterns) => {
  const normalized = normalizeCompare(value);
  if (!normalized) return false;
  return patterns.some((pattern) => pattern.test(normalized));
};

const isLikelySenderOrg = (value, letterSettings = {}) => {
  const normalized = normalizeCompare(value);
  if (!normalized) return false;

  const senderCandidates = [
    letterSettings.orgName,
    letterSettings.orgAbbrev,
    DEFAULT_INVITATION_LETTER.orgName,
    DEFAULT_INVITATION_LETTER.orgAbbrev,
  ]
    .map(normalizeCompare)
    .filter(Boolean);

  if (senderCandidates.some((candidate) => normalized === candidate || normalized.includes(candidate))) {
    return true;
  }

  return matchesSenderPattern(value, SENDER_ORG_PATTERNS);
};

const isLikelySenderAddress = (value, letterSettings = {}) => {
  if (matchesSenderPattern(value, SENDER_ADDRESS_PATTERNS)) return true;

  const senderAddressParts = [
    letterSettings.poBox,
    letterSettings.officeAddress,
    DEFAULT_INVITATION_LETTER.poBox,
    DEFAULT_INVITATION_LETTER.officeAddress,
  ];

  return senderAddressParts.some((part) => {
    const senderNorm = normalizeCompare(part);
    const valueNorm = normalizeCompare(value);
    if (!senderNorm || !valueNorm) return false;
    return valueNorm.includes(senderNorm) || senderNorm.includes(valueNorm);
  });
};

export const sanitizeRecipientAgainstSender = (recipient = {}, letterSettings = {}) => {
  if (!recipient?.recipientName) return recipient;

  const institutionLooksLikeSender = isLikelySenderOrg(
    recipient.recipientInstitution,
    letterSettings
  );
  const addressLooksLikeSender =
    isLikelySenderAddress(recipient.recipientAddressLine, letterSettings) ||
    (recipient.recipientAddressLines || []).some((line) =>
      isLikelySenderAddress(line, letterSettings)
    );
  const cityLooksLikeSender =
    isLikelySenderAddress(recipient.recipientCity, letterSettings) ||
    matchesSenderPattern(recipient.recipientCity, [/dar es salaam/i]);

  const shouldClearAddress =
    institutionLooksLikeSender || addressLooksLikeSender || cityLooksLikeSender;

  return {
    ...recipient,
    recipientInstitution: institutionLooksLikeSender ? '' : recipient.recipientInstitution,
    recipientAddressLine: shouldClearAddress ? '' : recipient.recipientAddressLine,
    recipientAddressLines: shouldClearAddress ? [] : recipient.recipientAddressLines,
    recipientCity:
      shouldClearAddress || cityLooksLikeSender ? '' : recipient.recipientCity,
  };
};

export const LEGACY_REF_NUMBER_TEMPLATE = 'TDA/AGM-{{year}}/6/{{ref_suffix}}';

export const normalizeRefNumberTemplate = (template) => {
  const value = String(template || '').trim();
  if (
    !value ||
    value === LEGACY_REF_NUMBER_TEMPLATE ||
    /AGM-\{\{year\}\}\/6\//.test(value)
  ) {
    return DEFAULT_INVITATION_LETTER.refNumberTemplate;
  }
  return value;
};

export const formatRefSuffix = (value) => {
  const raw = String(value || '').trim();
  if (!raw) return '0001';

  const trailingNumber = raw.match(/(\d+)\s*$/);
  if (trailingNumber) {
    return String(parseInt(trailingNumber[1], 10)).padStart(4, '0').slice(-4);
  }

  const confMatch = raw.match(/^CONF-(\d+)/i);
  if (confMatch) {
    return confMatch[1].slice(-4).padStart(4, '0');
  }

  const digits = raw.replace(/\D/g, '');
  if (digits.length >= 4) {
    return digits.slice(-4);
  }
  if (digits.length > 0) {
    return digits.padStart(4, '0');
  }

  return '0001';
};

export const deriveRefSuffixFromRegistration = (registration) => {
  if (!registration) return '0001';

  const qrCode = String(registration.qr_code || '').trim();
  if (qrCode) {
    return formatRefSuffix(qrCode);
  }

  const id = String(registration.id || '').trim();
  if (id) {
    let hash = 0;
    for (let i = 0; i < id.length; i += 1) {
      hash = (hash * 31 + id.charCodeAt(i)) % 10000;
    }
    return String(hash).padStart(4, '0');
  }

  return '0001';
};

export const resolveRefNumber = (template, { year, ref_suffix: refSuffix }) =>
  String(normalizeRefNumberTemplate(template))
    .replace(/\{\{year\}\}/g, year || new Date().getFullYear())
    .replace(/\{\{ref_suffix\}\}/g, formatRefSuffix(refSuffix));

export const buildLetterData = (
  invitationLetter,
  registration = null,
  conferenceSettings = {},
  leadershipMembers = null
) => {
  const base = mergeInvitationLetterSettings(invitationLetter, conferenceSettings);
  const recipient = sanitizeRecipientAgainstSender(
    buildRecipientFromRegistration(registration),
    base
  );
  const now = new Date();
  const letterDay = base.letterDay || String(now.getDate());
  const letterMonth = base.letterMonth || MONTHS[now.getMonth()][0];
  const letterYear = base.letterYear || String(now.getFullYear());
  const refNumber = resolveRefNumber(base.refNumberTemplate, {
    year: letterYear,
    ref_suffix: recipient.ref_suffix || '0001',
  });
  const leadershipFooter =
    leadershipMembers?.length > 0
      ? buildLeadershipFooterFromMembers(leadershipMembers)
      : { columns: [] };

  return {
    ...base,
    ...recipient,
    letterDay,
    letterMonth,
    letterYear,
    refNumber,
    leadershipFooter,
  };
};

export const buildSubjectEn = (data) => {
  const eventOrdinalEn = ordinalSuffix(data.eventNumber);
  const locationUpper = String(data.location || '').toUpperCase();
  return `INVITATION TO PARTICIPATE IN THE ${eventOrdinalEn.toUpperCase()} SCIENTIFIC CONFERENCE, CONTINUING PROFESSIONAL DEVELOPMENT WORKSHOP AND ANNUAL GENERAL MEETING FROM ${ordinalSuffix(data.eventStartDay).toUpperCase()} TO ${ordinalSuffix(data.eventEndDay).toUpperCase()} ${String(data.eventMonth).toUpperCase()}, ${data.eventYear} ${locationUpper}`;
};

export const resolveInvitationAssetUrl = (src) => {
  const path = String(src || '').trim();
  if (!path) return '';
  const normalized =
    path === '/images/tda-stamp.png' ? '/images/tda-official-stamp.png' : path;
  const separator = normalized.includes('?') ? '&' : '?';
  return `${normalized}${separator}v=20260805`;
};

export const formatLetterDateSw = (day, monthEn, year) => {
  const monthSw = monthToSwahili(monthEn);
  return `${monthSw} ${day}, ${year}`;
};

const findFeeByLabel = (fees, pattern) =>
  (fees || []).find((row) => pattern.test(String(row.label || '')));

export const buildSwahiliFeesList = (fees = DEFAULT_INVITATION_FEES) => {
  const conferenceFees = (fees || []).filter(
    (row) => !/annual|subscription/i.test(String(row.label || ''))
  );
  const member =
    findFeeByLabel(conferenceFees, /active member/i) ||
    conferenceFees.find((row) => /member/i.test(row.label) && !/non-?member/i.test(row.label)) ||
    conferenceFees[0];
  const nonMember = findFeeByLabel(conferenceFees, /non-?member/i) || conferenceFees[1];
  const international = findFeeByLabel(conferenceFees, /international/i) || conferenceFees[2];
  const student = findFeeByLabel(conferenceFees, /student/i) || conferenceFees[3];

  return [
    {
      key: 'i',
      text: `Wanataaluma wanachama hai - malipo ya mapema (early bird) - ${member?.amount || '150,000/='}`,
    },
    {
      key: 'ii',
      text: `Wanataaluma wasio wanachama hai - malipo ya mapema (early bird) - ${nonMember?.amount || '250,000/='}`,
    },
    {
      key: 'iii',
      text: `Malipo siku ya kongamano (on site) - ${member?.onsite || '180,000/='} kwa mwanachama hai`,
    },
    {
      key: 'iv',
      text: `Malipo siku ya kongamano (on site) - ${nonMember?.onsite || '280,000/='} kwa wasio wanachama`,
    },
    {
      key: 'v',
      text: `Wageni kutoka nje ya nchi - ${international?.amount || 'Usd 200'}`,
    },
    {
      key: 'vi',
      text: `Mwanafunzi (undergraduate/diploma) - ${student?.amount || '35,000/='}`,
    },
  ];
};

export const buildSubjectSw = (data) => {
  const eventMonthSw = monthToSwahili(data.eventMonth).toUpperCase();
  const locationSw = String(data.locationSw || 'MKOA WA KATAVI').toUpperCase();
  const recipientUpper = String(data.recipientName || 'MWALIKIWA').toUpperCase();
  return `MWALIKO WA ${recipientUpper} KUSHIRIKI MKONGAMANO LA ${data.eventNumber} LA KISAYANSI, MKUTANO MKUU WA MWAKA WA CHAMA CHA WATAALAM WA AFYA YA KINYWA NA MENO TANZANIA TAREHE ${data.eventStartDay} HADI ${data.eventEndDay} ${eventMonthSw}, ${data.eventYear} ${locationSw}`;
};

export const DEFAULT_EMPLOYER_BODY_SECTIONS_SW = DEFAULT_BODY_SECTIONS_SW.map((section) => {
  if (section.id === 'para5') {
    return {
      ...section,
      html: p(
        'Uongozi wa TDA, unaiomba ofisi yako kumruhusu na kumuwezesha {{employeeNameUpper}} kushiriki katika kongamano na mazoezi tangulizi kama ilivyoelezwa hapo juu.'
      ),
    };
  }
  return { ...section };
});

export const DEFAULT_EMPLOYER_INVITATION_LETTER = {
  ...DEFAULT_INVITATION_LETTER,
  bodySections: {
    sw: Object.fromEntries(
      DEFAULT_EMPLOYER_BODY_SECTIONS_SW.map((section) => [section.id, { html: section.html }])
    ),
  },
};

export const EMPLOYER_LETTER_PLACEHOLDERS = [
  { key: 'employeeName', label: 'Employee full name' },
  { key: 'employeeNameUpper', label: 'Employee name (UPPERCASE)' },
  { key: 'employerContactTitle', label: 'Employer contact title' },
  { key: 'employerInstitution', label: 'Employer institution' },
  { key: 'employerAddressLine', label: 'Employer address / P.O. Box' },
  { key: 'employerCity', label: 'Employer city / region' },
  ...LETTER_PLACEHOLDERS.filter(
    (item) => !['recipientName', 'recipientNameUpper'].includes(item.key)
  ),
];

export const getDefaultEmployerBodySections = () => DEFAULT_EMPLOYER_BODY_SECTIONS_SW;

export const mergeEmployerBodySections = (stored = {}) => {
  const defaults = DEFAULT_EMPLOYER_BODY_SECTIONS_SW;
  const langStored = stored?.sw || stored || {};
  const merged = {};
  defaults.forEach((section) => {
    const saved = langStored[section.id];
    merged[section.id] = {
      ...section,
      html: saved?.html ?? saved ?? section.html,
    };
  });
  return merged;
};

export const mergeEmployerInvitationLetterSettings = (stored = {}, conferenceSettings = {}) => {
  const merged = mergeInvitationLetterSettings(stored, conferenceSettings);
  return {
    ...DEFAULT_EMPLOYER_INVITATION_LETTER,
    ...merged,
    ...stored,
    refNumberTemplate: normalizeRefNumberTemplate(stored.refNumberTemplate || merged.refNumberTemplate),
    fees: stored.fees?.length ? stored.fees : DEFAULT_EMPLOYER_INVITATION_LETTER.fees,
    bodySections: {
      sw: mergeEmployerBodySections(stored.bodySections),
    },
  };
};

export const buildEmployerLetterPlaceholderMap = (data = {}) => ({
  ...buildLetterPlaceholderMap(data),
  employeeName: data.employeeName || '',
  employeeNameUpper: String(data.employeeName || 'MFANYIKAZI').toUpperCase(),
  employerContactTitle: data.employerContactTitle || '',
  employerInstitution: data.employerInstitution || '',
  employerAddressLine: data.employerAddressLine || '',
  employerCity: data.employerCity || '',
});

export const getEmployerSectionHtml = (data, sectionId) => {
  const sections = data.bodySections?.sw || mergeEmployerBodySections(data.bodySections);
  const section =
    sections[sectionId] ||
    DEFAULT_EMPLOYER_BODY_SECTIONS_SW.find((item) => item.id === sectionId);
  const html = section?.html || '';
  return interpolatePlaceholderMap(html, buildEmployerLetterPlaceholderMap(data));
};

export const resolveEmployerSubjectLine = (data) => {
  const html = getEmployerSectionHtml(data, 'subject');
  const plain = html.replace(/<[^>]+>/g, '').trim();
  if (plain) return html;
  const eventMonthSw = monthToSwahili(data.eventMonth).toUpperCase();
  const locationSw = String(data.locationSw || 'MKOA WA KATAVI').toUpperCase();
  const employeeUpper = String(data.employeeName || 'MFANYIKAZI').toUpperCase();
  return `MWALIKO WA ${employeeUpper} KUSHIRIKI MKONGAMANO LA ${data.eventNumber} LA KISAYANSI, MKUTANO MKUU WA MWAKA WA CHAMA CHA WATAALAM WA AFYA YA KINYWA NA MENO TANZANIA TAREHE ${data.eventStartDay} HADI ${data.eventEndDay} ${eventMonthSw}, ${data.eventYear} ${locationSw}`;
};

export const buildEmployerLetterData = (
  employerLetter,
  registration = null,
  employerInput = {},
  conferenceSettings = {},
  leadershipMembers = null,
  options = {}
) => {
  const base = mergeEmployerInvitationLetterSettings(employerLetter, conferenceSettings);
  const recipient = buildRecipientFromRegistration(registration);
  const employeeName =
    recipient.recipientName ||
    String(options.membershipFullName || options.memberFullName || '').trim();
  const now = new Date();
  const letterDay = base.letterDay || String(now.getDate());
  const letterMonth = base.letterMonth || MONTHS[now.getMonth()][0];
  const letterYear = base.letterYear || String(now.getFullYear());
  const refNumber = resolveRefNumber(base.refNumberTemplate, {
    year: letterYear,
    ref_suffix: recipient.ref_suffix || '0001',
  });
  const leadershipFooter =
    leadershipMembers?.length > 0
      ? buildLeadershipFooterFromMembers(leadershipMembers)
      : { columns: [] };

  return {
    ...base,
    employerContactTitle: String(employerInput.employerContactTitle || '').trim(),
    employerInstitution: String(employerInput.employerInstitution || '').trim(),
    employerAddressLine: String(employerInput.employerAddressLine || '').trim(),
    employerCity: String(employerInput.employerCity || '').trim(),
    employeeName,
    employeeNameUpper: String(employeeName || 'MFANYIKAZI').toUpperCase(),
    ref_suffix: recipient.ref_suffix,
    letterDay,
    letterMonth,
    letterYear,
    refNumber,
    leadershipFooter,
  };
};
